import { render, staticRenderFns } from "./EventPopup.vue?vue&type=template&id=4f7f840c"
import script from "./EventPopup.vue?vue&type=script&lang=js"
export * from "./EventPopup.vue?vue&type=script&lang=js"
import style0 from "./EventPopup.vue?vue&type=style&index=0&id=4f7f840c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports